import React, {memo} from 'react';

const EntityTableCol = memo(
    ({
        column: {
            columnInfo: {pathDetails, attrFormatter, columnId},
            value,
        },
        row: {entity},
    }) => {
        const CellFormatter = attrFormatter;

        return (
            <td data-column-id={columnId}>
                <CellFormatter.Formatter
                    entityType={pathDetails.finalAttribute.dataType}
                    formatter={attrFormatter}
                    entity={value}
                    parentEntity={entity}
                />
            </td>
        );
    },
);
EntityTableCol.displayName = 'EntityTableCol';

export {EntityTableCol};
